import Vue from 'vue'
import { baseURL } from '../config'
// 子账号-列表 
export const childAccountList = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 子账号-修改 
export const updateChildAccount = (token, data) => Vue.prototype.postAxios(baseURL + "/index.php?mod=inc&act=ordersys&str=updateChildAccount&token=" + token, data)
// 子账号-修改 
export const addChildAccount = (token, data) => Vue.prototype.postAxios(baseURL + "/index.php?mod=inc&act=ordersys&str=addChildAccount&token=" + token, data)